import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const ListIcon = ({
  color, fillOpacity, ...props
}) => (
  <svg
    {...helpers.getSvgDimensionsProps(props)}
    {...props}
  >
    <path
      fill={color}
      d="M17.1875 2.1875H2.8125C2.4668 2.1875 2.1875 2.4668 2.1875 2.8125V17.1875C2.1875 17.5332 2.4668 17.8125 2.8125 17.8125H17.1875C17.5332 17.8125 17.8125 17.5332 17.8125 17.1875V2.8125C17.8125 2.4668 17.5332 2.1875 17.1875 2.1875ZM16.4062 16.4062H3.59375V3.59375H16.4062V16.4062ZM9.60938 7.8125H13.2031C13.2891 7.8125 13.3594 7.74219 13.3594 7.65625V6.71875C13.3594 6.63281 13.2891 6.5625 13.2031 6.5625H9.60938C9.52344 6.5625 9.45312 6.63281 9.45312 6.71875V7.65625C9.45312 7.74219 9.52344 7.8125 9.60938 7.8125ZM9.60938 10.625H13.2031C13.2891 10.625 13.3594 10.5547 13.3594 10.4688V9.53125C13.3594 9.44531 13.2891 9.375 13.2031 9.375H9.60938C9.52344 9.375 9.45312 9.44531 9.45312 9.53125V10.4688C9.45312 10.5547 9.52344 10.625 9.60938 10.625ZM9.60938 13.4375H13.2031C13.2891 13.4375 13.3594 13.3672 13.3594 13.2812V12.3438C13.3594 12.2578 13.2891 12.1875 13.2031 12.1875H9.60938C9.52344 12.1875 9.45312 12.2578 9.45312 12.3438V13.2812C9.45312 13.3672 9.52344 13.4375 9.60938 13.4375ZM6.64062 7.1875C6.64062 7.3947 6.72294 7.59341 6.86945 7.73993C7.01596 7.88644 7.21467 7.96875 7.42188 7.96875C7.62908 7.96875 7.82779 7.88644 7.9743 7.73993C8.12081 7.59341 8.20312 7.3947 8.20312 7.1875C8.20312 6.9803 8.12081 6.78159 7.9743 6.63507C7.82779 6.48856 7.62908 6.40625 7.42188 6.40625C7.21467 6.40625 7.01596 6.48856 6.86945 6.63507C6.72294 6.78159 6.64062 6.9803 6.64062 7.1875ZM6.64062 10C6.64062 10.2072 6.72294 10.4059 6.86945 10.5524C7.01596 10.6989 7.21467 10.7812 7.42188 10.7812C7.62908 10.7812 7.82779 10.6989 7.9743 10.5524C8.12081 10.4059 8.20312 10.2072 8.20312 10C8.20312 9.7928 8.12081 9.59409 7.9743 9.44757C7.82779 9.30106 7.62908 9.21875 7.42188 9.21875C7.21467 9.21875 7.01596 9.30106 6.86945 9.44757C6.72294 9.59409 6.64062 9.7928 6.64062 10ZM6.64062 12.8125C6.64062 13.0197 6.72294 13.2184 6.86945 13.3649C7.01596 13.5114 7.21467 13.5938 7.42188 13.5938C7.62908 13.5938 7.82779 13.5114 7.9743 13.3649C8.12081 13.2184 8.20312 13.0197 8.20312 12.8125C8.20312 12.6053 8.12081 12.4066 7.9743 12.2601C7.82779 12.1136 7.62908 12.0312 7.42188 12.0312C7.21467 12.0312 7.01596 12.1136 6.86945 12.2601C6.72294 12.4066 6.64062 12.6053 6.64062 12.8125Z"
    />
  </svg>
);

ListIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

ListIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(20, 20),
  ...helpers.getViewBoxProperty({ width: 20, height: 20 }),
};

export default ListIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/list-v2.js